export class ActionItemSaveNoteModel {
    userID: number;
    actionNoteId: number;
    updateId: number;
    actionId: number;
    notes: string;
}
